<div class="flex flex-col h-screen overflow-hidden dark:bg-black">

  <!-- no painel lateral da extensão SisNot ↔ SEI: só a tela (editar/cadastrar), sem topo e menu -->
  @if (!noPainel) {
  <app-header></app-header>

  <!-- Barra de navegação horizontal -->
  <div class="nav-bar bg-white border-b border-gray-200 dark:bg-zinc-900 dark:border-zinc-800 relative z-10 py-3">

    <nav class="flex items-center justify-center gap-1">
      @for (item of navItems; track $index) {
        <a [routerLink]="item.route"
           routerLinkActive="nav-item-active"
           class="nav-item flex flex-col items-center gap-0.5 px-4 py-1 rounded-lg
                  text-gray-500 hover:text-red-500 hover:bg-red-50
                  dark:text-gray-400 dark:hover:text-white dark:hover:bg-red-950
                  transition-all duration-150 cursor-pointer">
          <span *appDynamicIcon="{ component: item.icon, inputs: { color: 'currentColor' } }"></span>
          <span class="text-xs font-medium whitespace-nowrap">{{ item.name }}</span>
        </a>
      }
      @if (sei.liberado()) {
        <!-- Bot SisNot ↔ SEI: só quem tem a integração com o SEI liberada no perfil -->
        <a routerLink="/bot-sei"
           routerLinkActive="nav-item-active"
           class="nav-item relative flex flex-col items-center gap-0.5 px-4 py-1 rounded-lg
                  text-gray-500 hover:text-red-500 hover:bg-red-50
                  dark:text-gray-400 dark:hover:text-white dark:hover:bg-red-950
                  transition-all duration-150 cursor-pointer">
          <svg viewBox="0 0 48 48" fill="none" class="w-6 h-6" aria-hidden="true">
            <line x1="24" y1="5" x2="24" y2="11" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
            <circle cx="24" cy="5" r="3" fill="currentColor"/>
            <rect x="9" y="11" width="30" height="24" rx="7" stroke="currentColor" stroke-width="3"/>
            <circle cx="18" cy="22" r="3.5" fill="currentColor"/>
            <circle cx="30" cy="22" r="3.5" fill="currentColor"/>
            <path d="M18 29.5h12" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
            <path d="M9 21H5v7h4M39 21h4v7h-4" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/>
            <path d="M16 35v6M32 35v6" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
          </svg>
          <span class="text-xs font-medium whitespace-nowrap">Bot</span>
          @if (bot.rodando() || bot.lendoCaixa()) {
            <!-- pesquisando em segundo plano (pode estar em outra tela) -->
            <span class="absolute -top-1 right-0 rounded-full bg-[#E41B2E] px-1.5 text-[10px] font-bold leading-4 text-white"
                  [title]="bot.lendoCaixa() ? 'Lendo a caixa no SEI…' : 'Pesquisando no SEI…'">
              {{ bot.lendoCaixa() ? 'caixa' : bot.progresso().pct + '%' }}
            </span>
          }
        </a>
      }
      @if (isAdmin) {
        <a routerLink="/admin"
           routerLinkActive="nav-item-active"
           class="nav-item flex flex-col items-center gap-0.5 px-4 py-1 rounded-lg
                  text-gray-500 hover:text-red-500 hover:bg-red-50
                  dark:text-gray-400 dark:hover:text-white dark:hover:bg-red-950
                  transition-all duration-150 cursor-pointer">
          <i class="pi pi-shield text-xl"></i>
          <span class="text-xs font-medium whitespace-nowrap">Administração</span>
        </a>
      }
    </nav>

  </div>
  }

  <main class="flex-1 overflow-auto bg-gray-100 dark:bg-zinc-950" [ngClass]="noPainel ? 'p-2' : 'px-6 pb-6 pt-3'">
    <router-outlet/>
  </main>

</div>
